/**
 * WebSocket 消息常量定义
 *
 * 对应后端 models 包中的常量定义
 */

// ============ 事件类型 (Event Types) ============
export const EVENT_TYPE = {
  MESSAGE: 'message',  // 普通聊天消息
  ACK: 'ack',         // 消息确认
  SYSTEM: 'system',   // 系统消息
};

// ============ 消息类型 (Message Types) ============
export const MSG_TYPE = {
  TEXT: 'text',     // 文本消息
  IMAGE: 'image',   // 图片消息
  VIDEO: 'video',   // 视频消息
  AUDIO: 'audio',   // 音频消息
  FILE: 'file',     // 文件消息
  CARD: 'card',     // 卡片消息
};

// ============ ACK 状态 (ACK Status) ============
export const ACK_STATUS = {
  RECEIVED: 'received',    // 服务端已收到
  DELIVERED: 'delivered',  // 已送达接收方
  READ: 'read',           // 已读
  FAILED: 'failed',       // 发送失败
};

// ============ 系统消息类型 (System Message Types) ============
export const SYSTEM_TYPE = {
  USER_ONLINE: 'user_online',       // 用户上线
  USER_OFFLINE: 'user_offline',     // 用户离线
  KICKED: 'kicked',                 // 被踢下线
  NOTIFICATION: 'notification',     // 通知
};

// 冻结所有对象，防止被意外修改
Object.freeze(EVENT_TYPE);
Object.freeze(MSG_TYPE);
Object.freeze(ACK_STATUS);
Object.freeze(SYSTEM_TYPE);

export default EVENT_TYPE;
